import AccountIndex from '../screens/account';
import AccountDetail from '../screens/account/detail';
import AccountNew from '../screens/account/new';
import APIKeyIndex from '../screens/api-key';
import APIKeyNew from '../screens/api-key/new';
import BatchIndex from '../screens/batch';
import BatchDetail from '../screens/batch/detail';
import BatchNew from '../screens/batch/new';
import DebitsBatchNew from '../screens/batch/new_debits';
import BusinessIndex from '../screens/business';
import LoginIndex from '../screens/login';
import LoginConfirm from '../screens/login/confirm';
import ManagerIndex from '../screens/manager';
import ManagerNew from '../screens/manager/new';
import TransactionIndex from '../screens/transaction';

const routes = [
  {
    path: '/',
    exact: true,
    private: true,
    component: BusinessIndex,
  },
  {
    path: '/accounts',
    exact: true,
    private: true,
    component: AccountIndex,
  },
  {
    path: '/accounts/new',
    exact: true,
    private: true,
    component: AccountNew,
  },
  {
    path: '/accounts/:accountID',
    exact: true,
    private: true,
    component: AccountDetail,
  },
  {
    path: '/accounts/:accountID/transactions',
    exact: true,
    private: true,
    component: TransactionIndex,
  },
  {
    path: '/accounts/:accountID/batches/(debits)?',
    exact: true,
    private: true,
    component: BatchIndex,
  },
  {
    path: '/accounts/:accountID/batches/:type(internal|outbound)?',
    exact: true,
    private: true,
    component: BatchNew,
  },
  {
    path: '/accounts/:accountID/batches/new-debits',
    exact: true,
    private: true,
    component: DebitsBatchNew,
  },
  {
    path: '/accounts/:accountID/batches/:batchID',
    exact: true,
    private: true,
    component: BatchDetail,
  },
  {
    path: '/managers',
    exact: true,
    private: true,
    component: ManagerIndex,
  },
  {
    path: '/managers/new',
    exact: true,
    private: true,
    component: ManagerNew,
  },
  {
    path: '/api-keys',
    exact: true,
    private: true,
    component: APIKeyIndex,
  },
  {
    path: '/api-keys/new',
    exact: true,
    private: true,
    component: APIKeyNew,
  },
  {
    path: '/login',
    exact: true,
    private: false,
    component: LoginIndex,
  },
  {
    path: '/login/confirm',
    exact: true,
    private: false,
    component: LoginConfirm,
  },
];

export default routes;
